import React, { useState, useMemo, useRef } from 'react';
import styled from 'styled-components';
import Pagination from '../Pagination/Pagination';
import { Verified } from '@mui/icons-material';

import {
  emoji_anger,
  emoji_disgust,
  emoji_fear,
  emoji_joy,
  emoji_neutral,
  emoji_sadness,
  emoji_surprise,
  GreenTick,
  NegativeSentiment,
  NeutralSentimenr,
  PositiveSentiment,
  QuestionIcon,
  sort_icon,
} from '../../Common/SvgIcon/CommonSvgIcons';
import { useEffect } from 'react';
import CollapsibleText from '../ReviewText/collapsibleText';
import PoPup from './PopupForComments';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCommentsList,
  getCommentsListPreview,
} from '../../store/redux/slices/topicSlice';

const Wrapper = styled.div`
  // margin: 50px 25px;
  height: 100%;
  /* width: 100%; */
  .header {
    // color: #636363;
    color: black;
    font-family: Montserrat;
    font-family: Inter;
    font-size: 18px;
    color: #2a2929;

    font-weight: 600;

    & > div:nth-child(2),
    & > div:nth-child(3) {
      color: #2a2929;
      color: black;
      font-family: Montserrat;
      font-family: Inter;
      font-size: 18px;
      font-weight: 600;
    }
  }
`;
const RowDataHeader = styled.div`
  display: grid;
  grid-template-columns: 45% 1fr 1fr 1fr;
  gap: 5px;
  text-align: left;
  position: sticky;
  background: white;
  z-index: 9;
  top: 0px;
  color: #2a2929;
  color: black;
  font-family: Open Sans;
  font-size: 15px;
  font-weight: 400;
  word-wrap: break-word;
  min-height:50px;
  font-family: Inter;

  & .review {
    padding-left: 15px;

    & > div:nth-child(1) {
      // color: #2a2929;
      color: #2a2929;
      // font-family: Montserrat;
      font-family: Inter;
      font-size: 15px;
      font-weight: 500;
      margin-bottom: 10px;
      width: 100%;
    }
  }

  & > div:nth-child(2),
  & > div:nth-child(3) {
    color: #2a2929;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    font-family: Inter;
  }

  & > div:not(:first-child) {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .filterColumn {
    cursor: pointer;
  }

  & .profile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    // font-family: Open Sans;
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
    color: #2a2929;

    & :last-child {
      // color: #636363;
    }
  }
`;
const RowData = styled.div`
  display: grid;
  grid-template-columns: 45% 1fr 1fr 1fr;
  gap: 5px;
  text-align: left;

  color: #2a2929;
  // font-family: Open Sans;
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  word-wrap: break-word;

  &:hover {
    background: #f0fff0;
    // cursor:pointer;
  }
  &:hover .collapsible-text {
    background: #f0fff0;
    color: #2a2929;
    // Change text color to white to make it visible
  }
  & .review {
    padding-left: 15px;

    & > div:nth-child(1) {
      color: #2a2929;
      // font-family: Montserrat;
      font-family: Inter;
      font-size: 15px;
      font-weight: 500;
      margin-bottom: 10px;
      width: 100%;
    }
  }

  & > div:nth-child(2),
  & > div:nth-child(3) {
    color: #2a2929;

    font-size: 15px;
    font-weight: 600;
    text-align: center;
  }

  & > div:not(:first-child) {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .filterColumn {
    cursor: pointer;
  }

  & .profile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    // font-family: Open Sans;
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;

    & :last-child {
      color: #2a2929;
    }
  }
`;
const EmotionsWrapper = styled.span`
  display: flex;
  gap: 40px;
  margin-left: 20px;
`;
const SentimentWrapper = styled.div`
  display: flex;
  gap: 10px;
  svg {
    width: 19px;
    height: 19px;
  }
`;
// const EmotionWrapper = styled.div`
//   display: flex;
//   gap: 20px;
//   margin-left: 20px;
// `;
const NoDataWrapper = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 20% 1fr min-content;
  gap: 2%;
  padding-top: 5px;
  box-sizing: border-box;

  color: #2a2929;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;

  min-height: 215px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const RowWrapper = styled.div`
  & > div {
    width: 100%;
    min-height: 120px;
    box-sizing: border-box;
    margin-top: 15px;
    border-radius: 15px;
    border: 1px solid #d9d9d9;
    padding: 20px 0;
  }
`;

const DateWrapper = styled.div`
  display: flex;
  align-items: end;
  gap: 30px;

  margin-bottom: 30px;

  font-size: 15px;
  font-weight: 600;

  & > :first-child {
    box-shadow: 0px 0px 11px 0px rgba(63, 63, 63, 0.25) inset;
    padding: 8px 7px 5px 7px;
    border-radius: 10px;

    & svg {
      width: 30px;
      height: 30px;
    }
  }

  & input {
    box-shadow: 0px 0px 8px 0px #a2a2a23d;
    border: 1px solid #d9d9d9;
    margin-top: 5px;
    margin-left: -3px;
    // font-family: Open Sans;
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    color: #2a2929;

    padding: 5px 20px;
    border-radius: 5px;
  }
`;
const InfoWrapper = styled.div`
color: #ffffff;
      position: absolute;
      left: 35px;
      top: -12px;
      min-width: 205px;
      max-width: 300px;
      min-height: 30px;
      // background: rgba(154, 191, 194, 0.2);
      background: linear-gradient(95.02deg, #a0d925 -65.35%, #006a68 100%);
      // background: #2d8955;

      padding: 10px;
      border-radius: 8px;
      z-index: 100;

      font-family: Open Sans;
      font-size: 10px;
      font-weight: 400;
      line-height: 12px;
      opacity: 0.9;
      box-shadow: 0px 4px 4px 0px #00000040;
      backdrop-filter: blur(40px);

      &:before {
        content: '';
        position: absolute;
        left: -14px;
        top: 12px;
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-right: 15px solid #a0d925;
        opacity: 0.9;
        z-index: 11;
      }
      & > ul {
        & > li {
          white-space: nowrap;
          line-height: 15px;
          margin-left: -25px;
        }
      }
`;
const IconWrapper = styled.div`
  position: relative;
  margintop: 2px;
  color: #2a2929;
  border-radius: 50%;
  border: 2.5px solid #636363;
  width: 14px;
  height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  // font-family: Montserrat;
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;

  cursor: pointer;
`;
const CommonMessagesTab = ({
  tableRef,
  currentPage = 1,
  setCurrentPage,
  isNews = false,
  download,
  reviews = [],
  filterCol = [2, 3, 4],
  columns = [],
  PageSize = 8,
  // startDate,
  // endDate,
  graphStyles = {
    gridTemplateColumns: '45% 1fr 1fr 1fr',
  },
  channel,
  infoVal = '',
  job_id = '',
  preview_uuid = '',
}) => {
  const [reviewsData, setReviewsData] = useState([]);
  const [infoText, setInfotext] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();
  const [indexFilter, setIndexFilter] = useState(-1);
  const { filterPayload } = useSelector((state) => state?.topicBuilder);
  // const [dateRange, setdateRange] = useState({
  //   startDate: startDate,
  //   endDate: endDate,
  // });
  useEffect(() => {
    setReviewsData([...reviews]);
  }, [reviews]);

  useEffect(() => {
    if (tableRef.current) {
      tableRef.current.scrollTop = 0;
    }
  }, [channel, infoVal, currentPage]);

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    if (download) {
      return reviewsData;
    } else {
      return reviewsData.slice(firstPageIndex, lastPageIndex);
    }
  }, [currentPage, reviewsData]);

  const formatDate = (dateString) => {
    try {
      const parts = dateString.split('/');

      const formattedDate = `${parts[2]}-${parts[1].padStart(
        2,
        '0'
      )}-${parts[0].padStart(2, '0')}`;

      const date = new Date(formattedDate);
      const options = {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      };
      return date.toLocaleDateString('en-US', options);
    } catch (error) {
      return '';
    }
  };

  function formatNumber(val) {
    if (val >= 1000000) {
      return (val / 1000000).toFixed(1) + 'M'; // Convert to million
    } else if (val >= 1000) {
      return (val / 1000).toFixed(1) + 'k';
    } else if (val > 0) {
      return val.toString();
    } else if (val == 0) {
      return 0;
    } else {
      return '';
    }
  }

  const handleFilter = (index) => {
    const tempReviews = [...reviewsData];
    /* tempReviews.sort(
      (a, b) =>
        b[columns[index].toLowerCase()] - a[columns[index].toLowerCase()]
    ); */
    if (indexFilter == index) {
      setIndexFilter(-1);
      if (columns[index] === 'Profile') {
        tempReviews.sort((a, b) => {
          const profileA = b.user_name || b.Name || '';
          const profileB = a.user_name || a.Name || '';
          return profileA.localeCompare(profileB);
        });
      } else if (columns[index] == 'Reposts') {
        tempReviews.sort((a, b) => a['retweet_count'] - b['retweet_count']);
      } else if (columns[index] == 'Title') {
        tempReviews.sort((a, b) => {
          const profileA = b.title || b.title || '';
          const profileB = a.title || a.title || '';
          return profileA.localeCompare(profileB);
        });
      } else {
        tempReviews.sort(
          (a, b) =>
            a[columns[index].toLowerCase()] - b[columns[index].toLowerCase()]
        );
      }
    } else {
      setIndexFilter(index);
      if (columns[index] === 'Profile' || columns[index] === 'Title') {
        tempReviews.sort((a, b) => {
          const profileA = a.user_name || a.Name || '';
          const profileB = b.user_name || b.Name || '';
          return profileA.localeCompare(profileB);
        });
      } else if (columns[index] == 'Reposts') {
        tempReviews.sort((a, b) => b['retweet_count'] - a['retweet_count']);
      } else {
        tempReviews.sort(
          (a, b) =>
            b[columns[index].toLowerCase()] - a[columns[index].toLowerCase()]
        );
      }
    }
    setReviewsData([...tempReviews]);
  };
  const handleOpenComment = (channel, message) => {
    if (
      (channel == 'facebook' ||
        channel == 'instagram' ||
        channel == 'youtube') &&
      message?.comments > 0
    ) {
      let value = message?.post_url;
      if (job_id) {
        dispatch(
          getCommentsList({
            value: value,
            channel: channel,
            job_id: job_id,
            filterPayload: filterPayload,
          })
        );
      } else {
        dispatch(
          getCommentsListPreview({
            value: value,
            channel: channel,
            filterPayload: filterPayload,
            job_id: preview_uuid,
          })
        );
      }
      setShowPopup(true);
    }
  };
  const getDetails = (channel, message) => {
    switch (channel) {
      case 'twitter':
        return formatNumber(message?.engagement) || 0;
      case 'youtube':
        return formatNumber(message?.comments) || 0;
      case 'facebook':
        return formatNumber(message?.comments) || 0;
      case 'instagram':
        return formatNumber(message?.comments) || 0;
      case 'flipkart':
        return formatNumber(message?.dislikes) || 0;
      case 'amazon':
        return (
          message.verified === 'Verified Purchase' && (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='27'
              height='27'
              viewBox='0 0 27 27'
              fill='#209E0B'
            >
              <path
                d='M0.920898 13.2318C4.6835 17.3029 8.33166 20.9679 11.8385 25.6033C15.6512 18.0201 19.5535 10.4105 25.9924 2.16971L24.2574 1.375C18.8205 7.14098 14.5965 12.599 10.9262 19.0853C8.37385 16.7861 4.24897 13.5324 1.73037 11.8607L0.920898 13.2318Z'
                fill='#209E0B'
              />
            </svg>
          )
        );
      default:
        return 0;
    }
  };
  function formatNumberVal(num) {
    if (num >= 1_000_000_000) {
      // Billion
      return (num / 1_000_000_000).toFixed(1) + 'B';
    } else if (num >= 1_000_000) {
      // Million
      return (num / 1_000_000).toFixed(1) + 'M';
    } else if (num >= 1000) {
      // Thousand
      return (num / 1000).toFixed(1) + 'k';
    } else if (num > 0) {
      return num.toString();
    } else if (num == 0) {
      return 0;
    } else {
      return '';
    }
  }
  return (
    <Wrapper>
      <RowDataHeader className='header' style={{ ...graphStyles }}>
        {columns.map((column, i) => {
          if (filterCol.includes(i + 1)) {
            return (
              <div
                className='filterColumn'
                key={i}
                onClick={() => handleFilter(i)}
              >
                {column}&nbsp;
                {sort_icon}
              </div>
            );
          }
          
          if (column === 'Posts') {
            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  key={i}
                  style={{
                    paddingLeft: '15px',
                    paddingRight: '10px',
                    color: '#2a2929',

                    textAlign: isNews == true ? 'center' : 'justify',
                  }}
                >
                  {column}
                </div>
                <IconWrapper
                  onMouseOver={() => setInfotext(true)}
                  onMouseLeave={() => setInfotext(false)}
                >
                  i{infoText && <InfoWrapper>{infoVal}</InfoWrapper>}
                </IconWrapper>
              </div>
            );
          }
          if(column === 'Comments') {
            <div
              key={i}
              style={{
                paddingLeft: '15px',
                color: '#2a2929',
                display: 'flex',
                alignItems: 'center',
                textAlign: isNews == true ? 'center' : 'justify',
              }}
            >
              {column}
            </div>
          }
          return (
            <div
              key={i}
              style={{
                paddingLeft: '15px',
                color: '#2a2929',

                textAlign: isNews == true ? 'center' : 'justify',
              }}
            >
              {column}
            </div>
          );

          // return <div key={i} style={{ paddingLeft: '15px' }}>{column}</div>;
        })}
      </RowDataHeader>
      <RowWrapper>
        {!(
          Array.isArray(currentTableData) &&
          currentTableData?.length === 1 &&
          Object.keys(currentTableData[0])?.length === 0 &&
          currentTableData[0]?.constructor === Object
        ) ? (
          currentTableData.map((message, index) =>
            isNews == true ? (
              <RowData key={index} style={{ ...graphStyles }}>
                <div className='profile'>
                  <span
                    style={{
                      color: '#292A2A',
                    }}
                  >
                    {message?.NewsSource} The Times of India
                  </span>
                </div>
                <div className='review'>
                  <div
                    style={{
                      color: '#292A2A',
                    }}
                  >
                    <CollapsibleText
                      channel={channel}
                      text={message?.text}
                      link={message?.post_url}
                    />
                  </div>
                </div>

                <div
                  className='helpful'
                  style={{
                    color: '#292A2A',
                  }}
                >
                  {message?.date}
                </div>
              </RowData>
            ) : (
              <RowData key={index} style={{ ...graphStyles }}>
                <div className='review'>
                  <div
                    style={{
                      color: '#292A2A',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    Post on{' '}
                    {formatDate(
                      channel === 'twitter'
                        ? message.date
                        : message.date || message['Reviewed on']
                    )}
                    <span
                      style={{
                        color: 'rgb(25, 118, 210)',
                        height: '23px',
                        marginLeft: '8px',
                      }}
                    >
                      {JSON.stringify(message?.verified) === 'true' && (
                        <Verified />
                      )}
                    </span>
                  </div>
                  <div>
                    <CollapsibleText
                      channel={channel}
                      text={
                        channel === 'twitter'
                          ? message.text
                          : message.posts ||
                            message.review_meta ||
                            message?.text
                      }
                      link={
                        channel === 'facebook' ||
                        channel === 'instagram' ||
                        channel === 'youtube'
                          ? message?.post_url
                          : channel === 'twitter'
                          ? message?.tweet_url
                          : ''
                      }

                      // background={'transparent'}
                    />
                  </div>
                  {message?.review_text != '' && (
                    <CollapsibleText
                      channel={channel}
                      text={message.review_text && message.review_text}

                      // background={'transparent'}
                    />
                  )}
                </div>
                {columns.includes('Profile') && (
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {channel == 'facebook' || channel == 'instagram' ? (
                      <></>
                    ) : (
                      <div
                        title={
                          message?.gender === 'male'
                            ? 'Male'
                            : message?.gender === 'female'
                            ? 'Female'
                            : ''
                        }
                        style={{ marginRight: '5px' }}
                      >
                        {message?.gender === 'male' ? (
                          <img
                            width={20}
                            src={require('../../assests/images/gendermale.png')}
                          />
                        ) : message?.gender === 'female' ? (
                          <img
                            width={20}
                            src={require('../../assests/images/genderfemale.png')}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    )}

                    <div
                      className='profile'
                      style={{
                        color: '#292A2A',
                      }}
                    >
                      <span
                        style={{
                          color: '#292A2A',
                          width: '90px',
                          wordBreak: 'break-all',
                        }}
                      >
                        {message.user_name || message.name}
                      </span>
                      <span
                        style={{
                          color: '#292A2A',
                        }}
                      >
                        {message['@user_name']}
                      </span>
                      {channel === 'instagram' && (
                        <span
                          style={{
                            fontSize: '12px',
                            color: '#2a2929',
                            width: '90px',
                            wordBreak: 'break-all',
                          }}
                        >
                          {message['handle']}
                        </span>
                      )}
                      {channel === 'instagram' && (
                        <span style={{ fontSize: '12px', color: '#2a2929' }}>
                          {formatNumberVal(message['followers_count'] || 0)}
                        </span>
                      )}
                    </div>
                  </div>
                )}
                {columns?.includes('Title') && (
                  <div
                    className='helpful'
                    style={{
                      color: '#292A2A',
                    }}
                  >
                    {message?.title}
                  </div>
                )}
                <div
                  className='helpful'
                  style={{
                    color: '#292A2A',
                  }}
                >
                  {channel === 'twitter'
                    ? formatNumber(message?.likes) || 0
                    : // formatNumber(message?.followers)
                    channel === 'amazon'
                    ? formatNumber(message.helpful) || 0
                    : formatNumber(message.likes) || 0}
                </div>
                <div
                  className='verified'
                  style={{
                    cursor:
                      (channel == 'facebook' ||
                        channel == 'instagram' ||
                        channel == 'youtube') &&
                      message?.comments > 0
                        ? 'pointer'
                        : 'context-menu',
                    color:
                      (channel == 'facebook' ||
                        channel == 'instagram' ||
                        channel == 'youtube') &&
                      message?.comments > 0
                        ? 'blue'
                        : '',
                  }}
                  onClick={() =>
                    // {}
                    handleOpenComment(channel, message)
                  }
                >
                  {channel === 'twitter'
                    ? formatNumber(message?.replies) || 0
                    : getDetails(channel, message)}
                </div>
                {channel === 'twitter' ? (
                  <div
                    style={{
                      color: '#292A2A',
                    }}
                  >
                    {(channel === 'twitter' && formatNumber(message?.views)) ||
                      0}
                  </div>
                ) : // : channel === 'facebook' ? (
                //   <div>{message?.shares || 0}</div>
                // )
                channel === 'instagram' || channel === 'youtube' ? (
                  <div
                    style={{
                      color: '#292A2A',
                    }}
                  >
                    {formatNumberVal(message?.views) || 0}
                  </div>
                ) : (
                  channel === 'facebook' && (
                    <div
                      style={{
                        color: '#292A2A',
                      }}
                    >
                      {message?.shares || 0}
                    </div>
                  )
                )}

                {channel === 'twitter' && (
                  <div
                    style={{
                      color: '#292A2A',
                    }}
                  >
                    {message?.retweet_count || 0}
                  </div>
                )}
                {channel === 'flipkart' && (
                  <div
                    style={{
                      color: '#292A2A',
                    }}
                  >
                    {message?.rating || 0}
                  </div>
                )}
                {(channel === 'twitter' || channel === 'flipkart') && (
                  <EmotionsWrapper>
                    <SentimentWrapper
                      title={
                        message?.sentiment === 1
                          ? 'Positive'
                          : message?.sentiment === -1
                          ? 'Negative'
                          : 'Neutral'
                      }
                    >
                      Sentiment:{' '}
                      {message?.sentiment === 1
                        ? PositiveSentiment
                        : message?.sentiment === -1
                        ? NegativeSentiment
                        : NeutralSentimenr}
                    </SentimentWrapper>

                    {message?.emotion?.length > 0 && (
                      <SentimentWrapper
                        title={
                          message?.emotion === 'neutral'
                            ? 'Neutral'
                            : message?.emotion === 'surprise'
                            ? 'Surprise'
                            : message?.emotion === 'joy'
                            ? 'Joy'
                            : message?.emotion === 'fear'
                            ? 'Fear'
                            : message?.emotion === 'sadness'
                            ? 'Sadness'
                            : message?.emotion === 'anger'
                            ? 'Anger'
                            : 'Disgust'
                        }
                      >
                        Emotion:
                        {message?.emotion === 'neutral'
                          ? emoji_neutral
                          : message?.emotion === 'surprise'
                          ? emoji_surprise
                          : message?.emotion === 'joy'
                          ? emoji_joy
                          : message?.emotion === 'fear'
                          ? emoji_fear
                          : message?.emotion === 'sadness'
                          ? emoji_sadness
                          : message?.emotion === 'anger'
                          ? emoji_anger
                          : emoji_disgust}
                      </SentimentWrapper>
                    )}
                  </EmotionsWrapper>
                )}
              </RowData>
            )
          )
        ) : (
          <NoDataWrapper>No Results Found</NoDataWrapper>
        )}
      </RowWrapper>
      {!download && (
        <Pagination
          currentPage={currentPage}
          totalCount={reviewsData.length}
          pageSize={PageSize}
          setCurrentPage={setCurrentPage}
          onPageChange={(page) => setCurrentPage(page)}
          reviewsData={reviewsData}
        />
      )}
      {/* {
        showPopup && */}

      {/* //   <PopUp minWidth={'70%'}  onClose={() => setShowPopup(false)}>

        //   {/* <div>{reviews[reviewMessage]}</div>  */}

      {/* // </PopUp> */}
      <PoPup
        topic={true}
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        popupwidth='80%'
        channel={channel}
        columns={
          channel == 'facebook'
            ? ['Comment', 'Profile', 'Reactions', 'Replies']
            : ['Comment', 'Profile', 'Likes', 'Replies']
        }
      />
      {/* } */}
    </Wrapper>
  );
};

export default CommonMessagesTab;
